import * as React from 'react';

export function stepDefault(stepNumber: number) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="11.9998" r="11.0769" fill="#0056D2" />
      <text x="8" y="17" fontFamily="Source Sans Pro" fontSize="16" fill="#FFFFFF">
        {stepNumber}
      </text>
    </svg>
  );
}

export function stepInactive(stepNumber: number) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12.9998" r="11.0769" fill="white" stroke="#E5E7E8" strokeWidth="2" />
      <text x="8" y="18" fontFamily="Source Sans Pro" fontSize="16" fill="#1F1F1F">
        {stepNumber}
      </text>
    </svg>
  );
}

export function labelIcon(stepNumber: number) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#F6BA5F" />
      <text x="8" y="17" fontFamily="Source Sans Pro" fontSize="16" fontWeight="bold" fill="#1F1F1F">
        {stepNumber}
      </text>
    </svg>
  );
}

export function StepIcon(props: { isLabel: boolean; stepNumber: number; isActive: boolean }) {
  return (
    <div>
      {props.isLabel && labelIcon(props.stepNumber)}
      {!props.isLabel && props.isActive && stepDefault(props.stepNumber)}
      {!props.isLabel && !props.isActive && stepInactive(props.stepNumber)}
    </div>
  );
}
